
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface SignupStatsProps {
  users: any[];
}

export const SignupStats = ({ users }: SignupStatsProps) => {
  const now = new Date();
  const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

  const getSignupsInPeriod = (startDate: Date) => {
    return users.filter(user => new Date(user.created_at) >= startDate).length;
  };

  const stats = {
    oneDay: getSignupsInPeriod(oneDayAgo),
    sevenDays: getSignupsInPeriod(sevenDaysAgo),
    thirtyDays: getSignupsInPeriod(thirtyDaysAgo),
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Last 24 Hours</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-4xl font-bold text-purple-600">{stats.oneDay}</p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Last 7 Days</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-4xl font-bold text-purple-600">{stats.sevenDays}</p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Last 30 Days</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-4xl font-bold text-purple-600">{stats.thirtyDays}</p>
        </CardContent>
      </Card>
    </div>
  );
};
